import React, { useState, useEffect } from 'react'
import axios from 'axios';
import './Administrator.css';
import Info from "./Info";
import BGHeader from "../Photoset/admi-bg-header.svg";
import BlueCircle from "../Photoset/admi-blue-circle.svg";
import WhiteCircle from '../Photoset/white-circle.svg';
import Dean from '../Photoset/admi-dean-image.svg';
import Footer from '../UserPages/Footer';
import CardProfile from "../UserPages/CardProfile";


function Administrator() {

    const [adminis, setAdminis] = useState([]);

    useEffect(() => {
        // Fetch staff data for the "social" subject
        axios.get('https://school-web-server-eight.vercel.app/')
            .then(result => {
                setAdminis(result.data);
            })
            .catch(error => {
                console.error('Failed to fetch staff members:', error);
            });
    }, []);



    return (
        <div>
            {/* use css of info.css except --ad */}
            <div className='Administrator'>
                <section className='header-info'>
                    <div className='bg-header'><img src={BGHeader} /></div>
                    <div className='header-text'>
                        <div className='left-h-t'>
                            <p>ฝ่ายบริหาร</p>
                        </div>
                        <div className='line-his-name'></div>
                        <div className='right-h-t'>
                            <h2>Administrators</h2>
                        </div>
                    </div>
                    <div className='white-circle'>
                        <img src={WhiteCircle} />
                    </div>
                    <div className='blue-two-thirds-circle-ad'>
                        <img src={BlueCircle} />
                    </div>
                </section>

                <section className='main-administrators'>
                    <div className='line'></div>
                    <div className='admini-staff'>
                        {adminis.map((admini) => (
                            <div className='admini-card-show' key={admini._id}>
                                <img src={`https://school-web-server-eight.vercel.app/ImageAdmini/${admini.image}`} alt={admini.name} />
                                <div className='info'>
                                    <h3>{admini.name}</h3>
                                    <p>{admini.position} {admini.acadStanding}</p>
                                    {/* <p>{admini.acadStanding}</p> */}
                                    <p>{admini.headOf}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='line'></div>
                </section>
                <div className='footer-info'><Footer /></div>
            </div>
        </div>
    )
};

export default Administrator